"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const shopulta = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-shopulta` : '') + (description ? ` desc-shopulta` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-shopulta"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-shopulta"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#232323",
    d: "M6.337 15.347q.438.792 1.018 1.5H.75a.75.75 0 0 1 0-1.5zM5.093 10.45q-.005.704.088 1.397H.75a.75.75 0 0 1 0-1.5h4.343zM6.383 5.347q-.407.722-.69 1.5H.75a.75.75 0 0 1 0-1.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#232323",
    fillRule: "evenodd",
    d: "M14.916 2a8.24 8.24 0 0 1 8.068 8.375l-.002.408a8.24 8.24 0 0 1-2.597 5.763l3.435 4.2a.75.75 0 0 1-1.161.95l-3.457-4.227a8.24 8.24 0 0 1-4.318 1.31 8.244 8.244 0 0 1-8.068-8.404A8.24 8.24 0 0 1 14.884 2zM14.9 3.5a6.743 6.743 0 0 0-6.585 6.904 6.745 6.745 0 0 0 6.585 6.874 6.74 6.74 0 0 0 6.584-6.903A6.74 6.74 0 0 0 14.9 3.5",
    clipRule: "evenodd"
  }));
};
var _default = exports.default = shopulta;